import React, { useState } from "react";
import styled from "styled-components";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    ContentActionsRow,
    BtnIcon
} from "../../components/SharedPageStyles";
import SeasonalityTab from "./SeasonalityTab";

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0px;
    flex: 1;
    min-height: 0;
`;

const SeasonalityPage = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const [isRefreshing, setIsRefreshing] = useState(false);

    const handleRefresh = () => {
        setIsRefreshing(true);
        setRefreshKey(prev => prev + 1);
        setTimeout(() => setIsRefreshing(false), 600);
    };

    return (
        <PageContainer>
            <ContentHeader>
                <ContentTitleBlock>
                    <Chip>Seasonality</Chip>
                    <Subtitle><em>Historical recurring market trends, pattern detection, and cyclical returns analysis.</em></Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow style={{ marginTop: '18px' }}>
                <BtnIcon
                    aria-label="Refresh data"
                    onClick={handleRefresh}
                    title="Refresh data"
                    disabled={isRefreshing}
                    $spinning={isRefreshing}
                >
                    ⟳
                </BtnIcon>
            </ContentActionsRow>

            <div style={{ marginTop: '20px', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <SeasonalityTab key={refreshKey} />
            </div>
        </PageContainer>
    );
};

export default SeasonalityPage;
